import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {BsModalService, BsModalRef} from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentName, ModalSize } from 'src/app/Enums/usersFilterEnums';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { OutwardService } from 'src/app/shared/services/outward.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { OfficesService } from 'src/app/shared/services/offices.service';

@Component({
  selector: 'app-outward-supervisor-header',
  templateUrl: './outward-supervisor-header.component.html',
  styleUrls: ['./outward-supervisor-header.component.less']
})
export class OutwardSupervisorHeaderComponent implements OnInit {

  modalRef: BsModalRef;
  private unsubscribe$ =new Subject<void>();
  @ViewChild('userame') officename: ElementRef;  
  @Output() searchByName = new EventEmitter();
  @Output() resetFilters = new EventEmitter();
  @Input() tableSettings;

  dateInputData: any = {};
  fromtimepickervalue: Date = new Date();
  fTime: Date = new Date;
  fromtimevalue: any;
  data:any;
  @ViewChild('fromtime') fromtime: ElementRef;

  constructor(
    private modalService: BsModalService, 
    private outwardService:OutwardService,
    private router: Router) { }

  ngOnInit() {
    this.dateInputData.EndDate = new Date();
    this.fromtimevalue = this.GetTimeForDates(new Date);
    this.dateInputData.StartDate = new Date();
    this.dateInputData.StartDate.setDate(this.dateInputData.StartDate.getDate() - 7);
    this.dateInputData.maxDate = new Date();
    this.dateInputData.FromMinDate = new Date();
    this.dateInputData.FromMinDate.setDate(this.dateInputData.StartDate.getDate() - 1095);

    this.outwardService.resetHeaders
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
      this.officename.nativeElement.value = '';
      this.dateInputData.StartDate = new Date();
      this.dateInputData.StartDate.setDate(this.dateInputData.StartDate.getDate()-7);
      this.dateInputData.EndDate = new Date();
      this.outwardService.refreshPage.next();
    })
  }

  fromTimePickerValueChanges(input: any) {
    if (input == null) {
      input = moment(this.fTime).format('MM/DD/YYYY') + ', ' + this.fromtime.nativeElement.value;
    }
    this.fTime = new Date(input);
    this.fromtimevalue = this.GetTimeForDates(this.fTime);
  }
  
  GetTimeForDates(date: Date): string {
    let time = moment(date).format("hh:mm A");
    return time;
  }
  
  addNewReg(){
    this.router.navigate(['/AddOutward']);
  }

  
  SearchByUser(username,Fdate,Edate) {
    var fdate = Fdate.toISOString();
    var edate = Edate.toISOString();
    this.searchByName.emit({username,fdate, edate});
  }


  ResetFilters() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Reset Filter';
    this.modalRef.content.description = 'Do you want to reset all filters';
    this.modalRef.content.buttonsTitle = {
      dismiss: 'Cancel',
      confirm: 'Reset',
      component: ComponentName.OutwardSupervisor
    }
  }

  hideDropdowns() {
    this.tableSettings.forEach(item => {
      item.displaysort = false;
    })
    // _.each(this.tableSettings, function (item) {
    //   item.displaysort = false;
    // })
  }
  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
